import * as React from 'react';

import Filter from '../../components/filters-ace/filter';
import ClearAll from '../../components/filters-ace/clear-all';
import CalendarText from '../../contexts/calendar-text';


import { FiltersContainerViewProps } from '../../components/filters-ace/container';

const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <CalendarText.Consumer>
            {
                text => (
                    <ul className="ace-cal-filters-list">
                        <Filter propertyToFilter="name" filterName={text.productionFilterLabelText} noSelectionText={text.productionSelectAllDropdownOption} />
                    </ul>
                )}
        </CalendarText.Consumer>
    )
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <CalendarText.Consumer>
            {
                text => (
                            <div className="ace-cal-filters-container" aria-hidden="false">
                                <FiltersListView {...props}></FiltersListView>
                            </div> 
                )}
        </CalendarText.Consumer>
    );
}

export default FiltersContainerView;